var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02953 6.97064C8.48346 6.4248 7.74297 6.11816 6.97087 6.11816C6.19877 6.11816 5.45827 6.4248 4.9122 6.97064L2.85287 9.02931C2.30678 9.57539 2 10.316 2 11.0883C2 11.8606 2.30678 12.6012 2.85287 13.1473C3.39895 13.6934 4.13959 14.0002 4.91187 14.0002C5.68414 14.0002 6.42479 13.6934 6.97087 13.1473L8.0002 12.118",
    stroke: "#34544F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9707 9.02929C7.51677 9.57513 8.25727 9.88177 9.02937 9.88177C9.80147 9.88177 10.542 9.57513 11.088 9.02929L13.1474 6.97062C13.6935 6.42454 14.0002 5.6839 14.0002 4.91162C14.0002 4.13935 13.6935 3.3987 13.1474 2.85262C12.6013 2.30654 11.8606 1.99976 11.0884 1.99976C10.3161 1.99976 9.57545 2.30654 9.02937 2.85262L8.00004 3.88196",
    stroke: "#34544F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.6322fc80df5ad9ab9507c4f69793f520.svg";
export { ForwardRef as ReactComponent };